import { IRequiredReport } from '@common/interfaces/requiredReport'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import { IAction } from '../apiMiddleware'
import * as actions from './actions'

export default combineReducers({
  loadingArray: loadingArrayReducer([actions.prefix]),
  list(state: IRequiredReport[] = [], action: IAction): IRequiredReport[] {
    switch (action.type) {
      case actions.CREATE_SUCCESS:
        return [...state, action.data as IRequiredReport]
      case actions.DELETE_SUCCESS:
        return state.filter(({ id }) => (action.data as IRequiredReport).id !== id)
      case actions.UPDATE_SUCCESS: {
        const updated = action.data as IRequiredReport
        return state.map((report) =>
          report.id === updated.id ? { ...report, ...updated } : report,
        )
      }
      case actions.LIST_SUCCESS:
        return action.data as IRequiredReport[]
      default:
        return state
    }
  },
  data: createLoadingDataReducer(
    [actions.LIST_REQUEST],
    [actions.CREATE_REQUEST, actions.UPDATE_REQUEST, actions.DELETE_REQUEST],
    true,
  ),
})
